$(document).ready(function() {

    var isAndroid = vcui.detect.isAndroid;
    var isIOS = vcui.detect.isIOS;
    var $content = $('.sign-up-guide');

    if(isAndroid){ 
        $content.find('.device-aos-qrcode').show();
        $content.find('.device-ios-qrcode').hide();
    }
    if(isIOS){ 
        $content.find('.device-aos-qrcode').hide();
        $content.find('.device-ios-qrcode').show();
    }
     /* BTOCSITE-3002 멤버십 페이지 수정 */
     $('.btn-mo-acc').click(function(){        
        $('.mo-only-acc').toggleClass('on');
    });

    $('.vertical-fixed table').clone(true).appendTo('.tb_row').addClass('tb-clone');

    //멤버십 가입 팝업
    $('.memPopup').click(function(){
        lgkorUI.confirm('', {
            title:'고객님은 멤버십 회원입니다. <br> 멤버십 관리 화면으로 이동할까요?', 
            cancelBtnName: '취소', okBtnName: '확인', 
            ok: function(){
                location.href = "/my-page/membership-info";
            }
        });
    });
    /* //BTOCSITE-3002 멤버십 페이지 수정 */


    //BTOCSITE-65935
    //sticky tab 클릭시 동기화
    $(window).on('viewTypeTabAfterChange',function(e, type){
        if($('.ui_stickyTab.view-type').eq(0).find('.btn-change').hasClass('twin-type')){
            $(window).trigger('all_view_list_twin','twin-type')
        }else{
            $(window).trigger('all_view_list_twin','list-type')
        }   
    });
    $('.list-change-cont').not('.inTab').each(function(){
        var $listIcon = $(this);
        $listIcon.find('.btn-change').on('click',function(){
            var $lists = $('.product-items-list .product-items');
            if($(this).hasClass('twin-type')){
                $(this).addClass('list-type').removeClass('twin-type')
                $(this).find('list-ico').addClass('active')
                $(this).find('twin-ico').removeClass('active')
                $lists && $lists.addClass('list-type').removeClass('twin-type')
                $(window).trigger('all_view_list_twin','list-type')
            }else{
                $(this).addClass('twin-type').removeClass('list-type')
                $(this).find('list-ico').removeClass('active')
                $(this).find('twin-ico').addClass('active')
                $lists && $lists.addClass('twin-type').removeClass('list-type')
                $(window).trigger('all_view_list_twin','twin-type')
            }
        });
    });
    //sticky tab 우측 리스트 버튼과, 타이틀 우측 리스트 버튼 동기화(리스트 타입 동기화) 
    $(window).on('all_view_list_twin',function(e, type){
        $('.list-change-cont').not('.inTab').each(function(){
            var $lists = $('.product-items-list .product-items');
            if(type == 'list-type'){
                $(this).find('.btn-change').addClass('list-type').removeClass('twin-type')
                $(this).find('.btn-change').find('list-ico').addClass('active')
                $(this).find('.btn-change').find('twin-ico').removeClass('active')
                $lists && $lists.addClass('list-type').removeClass('twin-type')
            }else{
                $(this).find('.btn-change').addClass('twin-type').removeClass('list-type')
                $(this).find('.btn-change').find('list-ico').removeClass('active')
                $(this).find('.btn-change').find('twin-ico').addClass('active')
                $lists && $lists.addClass('twin-type').removeClass('list-type')
            }
        })
        $('.ui_stickyTab.view-type').each(function(){
            var selectId = []
            $(this).find('.tabs').find('li').each(function(){
                selectId.push($(this).find('a').attr('href'))
            })
            if(type == 'list-type'){
                $(this).find('.btn-change').addClass('list-type').removeClass('twin-type')
                $(this).find('.btn-change').find('list-ico').addClass('active')
                $(this).find('.btn-change').find('twin-ico').removeClass('active')
                for(var i=0; i<selectId.length; i++){
                    $(selectId[i]).find('.product-items').addClass('list-type').removeClass('twin-type')
                }
            }else{
                $(this).find('.btn-change').addClass('twin-type').removeClass('list-type')
                $(this).find('.btn-change').find('list-ico').removeClass('active')
                $(this).find('.btn-change').find('twin-ico').addClass('active')
                for(var i=0; i<selectId.length; i++){
                    $(selectId[i]).find('.product-items').addClass('twin-type').removeClass('list-type')
                }
            }
        });
        $(window).trigger('resizeend')
    }).trigger('all_view_list_twin','twin-type')

    $(window).on('resizeend',function () {
        //제품 유닛 옵션 높이값 맞추기
        var $lists = $('.product-items.new-type > li');
        var resizeCol = 0;
        var colsArr = [];
        var maxH = 0;
        $lists.each(function(){
            var $this = $(this);
            if( $lists.eq(0).offset().top == $this.offset().top){
                resizeCol++;
            }
        });
        $lists.each(function(idx){
            var $this = $(this);
            var $thisItem = $(this).children().find('.item-middle-info');
            if(idx%resizeCol == 0){
                maxH = 0
                colsArr[idx%resizeCol] = []
            }
            colsArr[idx%resizeCol] = $thisItem;
            $thisItem.css('min-height','auto');
            if( $thisItem.outerHeight() > maxH ){
                maxH = $thisItem.outerHeight();
            }    
            if(idx%resizeCol == resizeCol-1){
                for(var i=0; i<colsArr.length; i++){
                    colsArr[i].css('min-height',maxH)
                }
            }
        })
    })
    ////BTOCSITE-65935
});
